import { createFileRoute, redirect, Outlet } from '@tanstack/react-router';
import { useRoleRegistrySync } from '@/lib/hooks/useRoleRegistrySync';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: ({ context, location }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({
        to: '/login',
        search: {
          // Save current location for redirect after login
          redirect: location.href,
        },
      });
    }
  },
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  // Removed useUserProfile call - let individual pages fetch when needed
  // This prevents duplicate fetches from multiple components mounting simultaneously
  // Keep the role registry warm so role labels/colors resolve app-wide.
  useRoleRegistrySync();
  return <Outlet />;
}
